export enum DateRangeParamType {
  ChangedTime = 0,
  CreationTime = 1,
}
